import { Injectable, TemplateRef } from '@angular/core';
import { SubjectHolder } from './subject-holder';
import { SolTooltipPosition } from '../models/core/sol-tooltip';
import { SolText } from '../models/core/sol-text';

export interface SolTooltipEntry {
  readonly id: string;
  readonly text: SolText;
  readonly position: SolTooltipPosition;
  readonly triggerBounds: DOMRect;
  readonly template?: TemplateRef<unknown>;
  readonly custom?: boolean;
  readonly wide?: boolean;
}

export interface TooltipServiceState {
  readonly tooltips: SolTooltipEntry[];
}

@Injectable({
  providedIn: 'root',
})
export class TooltipService extends SubjectHolder<TooltipServiceState> {
  constructor() {
    super({ tooltips: [] });
  }

  public show(entry: SolTooltipEntry): void {
    this.update(state => ({
      tooltips: [...state.tooltips.filter(t => t.id !== entry.id), entry],
    }));
  }

  public hide(id: string): void {
    this.update(state => ({
      tooltips: state.tooltips.filter(t => t.id !== id),
    }));
  }
}
